<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Career Opportunities at XipeTech</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Career</li>
            </ul>
        </div>
    </div>
</div>

<div class="space">
    <div class="container">
        <div class="th-sort-bar" *ngIf="records?.length > 0;">
            <div class=" row gy-4 justify-content-between align-items-center">
                <div class="col-lg">
                    <p class="woocommerce-result-count">
                        {{ records?.length || 0 }} {{ (records?.length === 1 ? 'job' : 'jobs') }} recommended for you
                    </p>
                </div>
            </div>
        </div>
        <div class="row gy-30" *ngIf="records?.length > 0; else noJobs">
            <!--========= Career Area =============-->
            <div class="col-lg-6 col-xxl-4" *ngFor="let data of records">
                <div class="job-post white-bg">
                    <div class="job-content smoke-bg">
                        <div class="job-post_date d-flex align-items-center justify-content-between">
                            <span class="date">{{ data.published_at }}</span>
                            <div class="icon">
                                <i class="fa-solid fa-heart"></i>
                            </div>
                        </div>
                        <div class="job-post_author d-sm-flex align-items-center text-center text-sm-start">
                            <div class="job-author">
                                <img [src]="data.cover_image" (error)="onImageError($event)" alt="{{ data.title }}" />
                            </div>
                            <div class="author-info">
                                <span class="company-name">XipeTech</span>
                                <span class="job-title">{{ data.location ?? 'XipeTech' }}</span>
                                <span class="location me-1"><i class="fa-light fa-location-dot"></i> {{ data.location ??
                                    'Lucknow' }}</span>
                                <span class="location experience"
                                    *ngIf="data.min_experience && data.min_experience.trim() !== ''">
                                    <i class="fa-light fa-clock"></i>
                                    {{ data.min_experience ?? '' }}
                                </span>
                            </div>
                        </div>
                        <div class="job-category" *ngIf="data.tags && data.tags.length > 0">
                            <a class="m-1" href="javascript:void(0);" *ngFor="let tag of data.tags">
                                {{ tag | titlecase }}
                            </a>
                        </div>
                    </div>
                    <div
                        class="job-wrapper d-sm-flex align-items-center justify-content-between text-center text-sm-start">
                        <span class="price" *ngIf="data.expected_salary && data.expected_salary.trim() !== ''">
                            <i class="fa-sharp fa-regular fa-indian-rupee-sign me-2"></i>
                            {{ data.expected_salary }}
                        </span>
                        <a routerLink="/careers/{{ data.slug }}"><span class="th-btn style3">Apply Now</span></a>
                    </div>
                </div>
            </div>
            <!--======= Pagination Area ============-->
            <div class="th-pagination mt-60 text-center mb-0" *ngIf="meta?.links?.length > 0">
                <ul>
                    <li *ngFor="let link of meta.links; let i = index">
                        <ng-container *ngIf="i !== 0"> <!-- Skip first "Previous" -->
                            <a [class.active]="link.active" [class.next-page]="i === meta.links.length - 1"
                                href="javascript:void(0)" (click)="link.page ? loadApiData(link.page, 12) : null">

                                <ng-container *ngIf="i === meta.links.length - 1; else normalLabel">
                                    <i class="fa-sharp fa-light fa-arrow-right"></i>
                                </ng-container>

                                <ng-template #normalLabel>{{ link.label }}</ng-template>
                            </a>
                        </ng-container>
                    </li>
                </ul>
            </div>
            <!--======= Pagination Area End ============-->
        </div>
        <!-- Fallback message if no jobs -->
        <ng-template #noJobs>
            <div class="col-12 text-center">
                <h2><strong>Currently No Job Openings</strong></h2>
                <p>At the moment, we don’t have any active job openings. <br>However, we are always on the lookout for
                    talented and passionate individuals<br> to join our team in the future. We encourage you to check
                    back
                    regularly<br> or follow us on our social media channels to stay updated on upcoming opportunities.
                </p>
            </div>
        </ng-template>
        <!--========= Career Area End =============-->
    </div>
</div>

<!--======== Footer Section ========-->
<app-footer></app-footer>